<template>
  <div id="authPage" v-if="!msal.isAuthenticated">
    <img src="/static/img/logo.png" class="center-block logo">

    <div class="text-center col-sm-12">
      <h1>Authentification</h1>
      <h4>Veuillez vous connecter.</h4>
      <!-- <router-link to="/" class="vertical-5p lead">Take me home.</router-link> -->
      <br>
      <button @click="$msal.signIn()">Connexion</button>
    </div>
  </div>
</template>

<script>
import { msalMixin } from 'vue-msal'

export default {
  name: 'AuthPage',
  mixins: [msalMixin],
  mounted: function() {
    if (this.msal.isAuthenticated) {
      console.log('Authenticated! Forwarding to home page...')
      this.$router.replace('/')
    }
  }
}
</script>

<style>
#notFound {
  padding: 10em;
  color: white;
}
</style>



// WEBPACK FOOTER //
// AuthPage.vue?c033e81e